module.exports = __webpack_public_path__ + "_assets/img/play-btn.98aedcfd.svg";